import { render } from "./Reference.vue?vue&type=template&id=73b8bc20&scoped=true&ts=true"
import script from "./Reference.vue?vue&type=script&lang=ts"
export * from "./Reference.vue?vue&type=script&lang=ts"

import "./Reference.vue?vue&type=style&index=0&id=73b8bc20&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b8bc20"]])

export default __exports__